import React, { useEffect } from 'react'
import MainFirst from '../components/MainFirst/MainFirst'
import MainSecond from '../components/MainSecond/MainSecond'
import SectionForm from '../components/SectionForm/SectionForm'
import WelcomeMain from '../components/WelcomeMain/WelcomeMain'

const StronaGlowna = () => {
	useEffect(() => {
		window.scrollTo({
			top: 0,
		})
	}, [])

	return (
		<>
			<WelcomeMain />
			<MainFirst />
			<MainSecond />
			<SectionForm />
		</>
	)
}

export default StronaGlowna
